// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251604/js/" + chunkId + "." + {"44":"91123456","225":"5e789bc5","481":"43211b39","486":"3014c079","770":"11d1bef3"}[chunkId] + ".0.8216809746449668.chunk.js";
};